import { PureComponent } from 'react';
import { connect } from 'react-redux';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import H5 from 'UIComponents/elements/headings/H5';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { FLINT } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import I18n from 'I18n';
import { ModalPages } from 'ContentData/constants/fonts';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import * as FontsActions from 'ContentData/actions/Fonts';
import * as fontsSelectors from 'ContentData/selectors/fonts';
import * as RequestStatus from 'ContentUtils/constants/RequestStatus';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.font.modals.upload.manage.${key}`;
const FONT_DOCS = 'https://knowledge.hubspot.com/website-pages/use-fonts-in-hubspot#use-custom-fonts';
const mapStateToProps = state => {
  return {
    customFonts: fontsSelectors.getCustomFonts(state),
    customFontsRequestStatus: fontsSelectors.getCustomFontsFetchStatus(state),
    deleteFontRequestStatus: fontsSelectors.getDeleteCustomFontRequestStatus(state)
  };
};
const mapDispatchToProps = {
  fetchCustomFonts: FontsActions.fetchCustomFonts,
  deleteFont: FontsActions.deleteCustomFont
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class ManageCustomFont extends PureComponent {
  constructor(props) {
    super(props);
    this.resetFontState = page => {
      const {
        handleUpdate
      } = this.props;
      handleUpdate(Object.assign({
        fontName: undefined,
        fontFiles: undefined,
        fontStyles: undefined,
        fontFilesUploaded: undefined,
        fontId: undefined,
        fontEdited: undefined,
        fontAdded: undefined
      }, page && {
        page
      }));
    };
    this.handleEditFont = fontId => {
      const {
        changePage,
        handleUpdate
      } = this.props;
      handleUpdate({
        fontId
      });
      changePage(ModalPages.EDIT);
    };
    this.handleDeleteFont = fontId => {
      const {
        deleteFont,
        usageTracker
      } = this.props;
      deleteFont(fontId).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
      this.setState({
        fontIdToDelete: undefined
      });
      usageTracker.track('ContentComponentsInteraction', {
        action: 'custom-fonts-delete-font'
      });
    };
    this.renderConfirmDeleteModal = fontId => {
      const {
        customFonts
      } = this.props;
      const fonts = Object.values(customFonts);
      const selectedFont = fonts.find(font => font.id === fontId);
      return /*#__PURE__*/_jsx(UIConfirmModal, {
        confirmLabel: I18n.text(i18nKey('confirmDelete.confirmButton')),
        confirmUse: "danger",
        description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: i18nKey('confirmDelete.body_jsx'),
          options: {
            href: FONT_DOCS,
            fontName: selectedFont.name
          },
          elements: {
            UILink,
            strong: 'strong'
          }
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('confirmDelete.header')
        }),
        size: "auto",
        use: "danger",
        onConfirm: () => this.handleDeleteFont(fontId),
        onReject: () => this.setState({
          fontIdToDelete: undefined
        }),
        rejectLabel: "Cancel",
        confirmButtonProps: {
          className: 'font-upload-manage-confirm-delete'
        }
      });
    };
    this.renderFont = font => {
      //TODO usage endpoint to populate static `not in use`

      return /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        className: "m-y-5",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-3",
          name: "fontFile",
          size: 32,
          color: FLINT
        }), /*#__PURE__*/_jsx(UIBox, {
          grow: 1,
          children: /*#__PURE__*/_jsx(H5, {
            "data-selenium": `font-upload-manage-font-name:${font.name}`,
            className: "m-bottom-1",
            children: font.name
          })
        }), /*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsx(UIDropdown, {
            buttonClassName: "m-x-6",
            buttonSize: "small",
            buttonText: I18n.text(i18nKey('actions')),
            "data-selenium": `font-upload-manage-dropdown:${font.name}`,
            children: /*#__PURE__*/_jsxs(UIList, {
              children: [/*#__PURE__*/_jsx(UIButton, {
                onClick: () => {
                  this.handleEditFont(font.id);
                },
                "data-selenium": `font-upload-manage-edit-button:${font.name}`,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: i18nKey('edit')
                })
              }), /*#__PURE__*/_jsx(UIButton, {
                onClick: () => {
                  this.setState({
                    fontIdToDelete: font.id
                  });
                },
                "data-selenium": `font-upload-manage-delete-button:${font.name}`,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: i18nKey('delete')
                })
              })]
            })
          })
        })]
      }, `custom-font-${font.id}`);
    };
    this.renderFontsList = () => {
      const {
        customFonts,
        customFontsRequestStatus,
        deleteFontRequestStatus
      } = this.props;
      //TODO sorting for list?? currently BE returns most recently created on top descending

      if ((customFontsRequestStatus || deleteFontRequestStatus) === (RequestStatus.UNINITIALIZED && RequestStatus.PENDING)) {
        return /*#__PURE__*/_jsx(UILoadingSpinner, {
          layout: "centered"
        });
      }
      return customFonts && Object.values(customFonts).map(font => this.renderFont(font));
    };
    this.renderDone = () => {
      const {
        onCancel
      } = this.props;
      return /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: () => onCancel(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('pagination.done')
        })
      });
    };
    this.renderAdd = () => {
      return /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: () => this.resetFontState(ModalPages.ADD),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('pagination.add')
        })
      });
    };
    this.state = {};
  }
  componentDidMount() {
    const {
      fetchCustomFonts
    } = this.props;
    fetchCustomFonts().catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    this.resetFontState();
  }
  componentDidUpdate(prevProps) {
    //TODO loading & error states for edit and delete
    const {
      deleteFontRequestStatus,
      fetchCustomFonts
    } = this.props;
    const {
      deleteFontRequestStatus: prevDeleteFontRequestStatus
    } = prevProps;
    if (deleteFontRequestStatus === RequestStatus.SUCCEEDED && prevDeleteFontRequestStatus !== RequestStatus.SUCCEEDED) {
      fetchCustomFonts().catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }
  }
  render() {
    const {
      customFontsRequestStatus,
      setErrorMessage,
      deleteFontRequestStatus
    } = this.props;
    const {
      fontIdToDelete
    } = this.state;
    if (customFontsRequestStatus === RequestStatus.FAILED) {
      setErrorMessage(i18nKey('error.fontsFetchFail'));
    }
    if (deleteFontRequestStatus === RequestStatus.FAILED) {
      setErrorMessage(i18nKey('error.fontDeleteFail'));
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: i18nKey('body_jsx'),
            options: {
              href: FONT_DOCS,
              external: true
            },
            elements: {
              UILink,
              strong: 'strong'
            }
          })
        }), this.renderFontsList()]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [this.renderDone(), this.renderAdd()]
      }), fontIdToDelete && this.renderConfirmDeleteModal(fontIdToDelete)]
    });
  }
}
export default connector(ManageCustomFont);